export const updateShipmentVisitOrderEndpoint = (shipmentUid: string, visitId: string) =>
  `/shipments/${shipmentUid}/visits/${visitId}/update-order`
